/*
 * @Descripttion: 接口基本配置
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-12-26 10:00:54
 */
import sha1 from "utils/sha1";
const base = {
  request: "",
  upload: "",
  video: "",
  pay: "",
  preRequest: "/cm-api",
  dbRequest: "/db-api",
  preUpload: "/img",
  preVideo: "/video",
  jgbRequest: "/jgb-api",
  jgbTokenRequest: "/jgbtoken-api",
};
switch (process.env.NODE_ENV) {
  case "development":
    base.request = base.preRequest;
    base.dbRequest = base.dbRequest;
    base.jgbRequest = base.jgbRequest;
    base.jgbTokenRequest = base.jgbTokenRequest;

    base.upload = "http://img4.nongji360.mobi";
    // base.upload = 'https://test-img4.nongji360.com'
    // base.upload = 'https://img4.nongji360.com'
    base.video = "https://datasp1.nongji360.com";
    base.pay = "https://cm-api.datian360.com";
    break;
  case "test":
    base.request = "https://test-cm-api.datian360.com";
    base.dbRequest = "https://test-db.nongji360.com/stage_api";
    base.jgbRequest = "";
    base.jgbTokenRequest = "";
    base.upload = "https://test-img4.nongji360.com";
    base.video = "http://datasp1.nongji360.mobi";
    base.pay = "https://test-cm-api.datian360.com";
    break;
  case "production":
    // base.request = "/stage_api";
    // base.dbRequest = "https://test-db.nongji360.com/stage_api";
    base.request = "/prod_api";
    base.dbRequest = "https://db.nongji360.com/prod_api";
    base.jgbRequest = "";
    base.jgbTokenRequest = "";
    base.upload = "https://img4.nongji360.com";
    base.video = "https://datasp1.nongji360.com";
    base.pay = "/yqs/api";
    break;
}
/**
 * @descripttion: 接口固定参数
 * @Author: juanjuanhui
 * @Date: 2021-06-23 20:41:23
 * @return {Object} 固定参数
 */
const admParam = () => {
  let user = JSON.parse(localStorage.getItem("user"));
  let timestamp = Math.floor(new Date().getTime() / 1000);
  if (!user) {
    user = { user_key: "", wui: "" };
  }
  return {
    bn: "140617.2",
    timestamp: timestamp,
    token: sha1.sha1("NJ360LoginAuth" + timestamp),
    terminal: 11,
    _origin: 7301,
    _uk: user.user_key,
    _wui: user.wui,
  };
};
export { base, admParam };
